import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { missingConfig } from './lib/firebase'
import { ErrorBoundary } from './components/ErrorBoundary'
import { AuthProvider } from './lib/auth'
import { DocsIndexProvider } from './lib/docsIndex'
import { Layout } from './components/Layout'
import { HomePage } from './routes/HomePage'
import { DocPage } from './routes/DocPage'
import { SearchPage } from './routes/SearchPage'
import { FavoritesPage } from './routes/FavoritesPage'
import { AdminPage } from './routes/AdminPage'
import { EditorPage } from './routes/EditorPage'
import { ExportPage } from './routes/ExportPage'

export default function App() {
  if (missingConfig.length) return <SetupNotice missing={missingConfig} />

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <DocsIndexProvider>
            <Routes>
              <Route element={<Layout />}>
                <Route index element={<HomePage />} />
                {/* Static routes are matched before the catch-all doc path below. */}
                <Route path="new" element={<EditorPage />} />
                <Route path="search" element={<SearchPage />} />
                <Route path="favorites" element={<FavoritesPage />} />
                <Route path="export" element={<ExportPage />} />
                <Route path="admin" element={<AdminPage />} />

                <Route path="d/:id/edit" element={<EditorPage />} />
                {/* `/d/{id}` is kept for old links and redirects to the canonical path. */}
                <Route path="d/:id" element={<DocPage />} />

                {/* `/glossary/en/rx/od` — the keyword lives in the URL. */}
                <Route path=":service/*" element={<DocPage />} />

                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </DocsIndexProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

function SetupNotice({ missing }: { missing: string[] }) {
  return (
    <div className="mx-auto max-w-lg px-6 py-24">
      <h1 className="text-xl font-semibold text-ink">Firebase config is missing</h1>
      <p className="mt-2 text-sm text-muted">
        Copy <code className="font-mono text-accent-text">.env.example</code> to{' '}
        <code className="font-mono text-accent-text">.env.local</code> and fill in the values from
        Firebase console → Project settings → Your apps.
      </p>
      <ul className="mt-4 space-y-1 font-mono text-xs text-subtle">
        {missing.map((k) => (
          <li key={k}>{k}</li>
        ))}
      </ul>
    </div>
  )
}
